import ServiceCategoryPage from "../components/ServiceCategoryPage";
import acRepairService from "../data/services/acRepairService";

function ACRepair() {
  return <ServiceCategoryPage service={acRepairService} />;
}

export default ACRepair;